export default __webpack_public_path__ + "static/media/jimmy.32262f48.png";